import { TBlockType } from '~/types/model.types';

export const LEAD_FORM_SESSION_STORAGE_KEY = 'public_cxStorage';
export const LEAD_FORM_RECAPTCHA_ACTION = 'submit_public_flow';

export enum LeadFormAllowedRouteKeys {
    FetchFlow = 'fetchFlow',
    SubmitLeadForm = 'submitPublicFlow',
    FetchLeadFormSubmitResults = 'fetchPublicFlowSubmitResults',
    FetchLeadFormExperiment = 'fetchPublicFlowExperiment'
}
export const ALLOWED_PUBLIC_ROUTE_KEYS = Object.values(
    LeadFormAllowedRouteKeys
);

export type PublicFlowsNonAllowedBlockTypes = Extract<
    TBlockType,
    'contract_block'
>;

export const LEAD_FORMS_NON_ALLOWED_BLOCK_TYPES_TO_DISPLAY_NAME_MAP: Record<
    PublicFlowsNonAllowedBlockTypes[number],
    string
> = {
    contract_block: 'Contract'
};

export const DEMO_LEAD_FORM_ID = '64d538d6a4b04900dce3f0ee';

//  was used for wizardv1, template is still live:
export const SCHEDULER_BANNER_FORM_ID = '65007d90c7c5830023bf3d48';

export const DIGITAL_PRODUCT_TEMPLATE_ID = '654a32f60a0cca0027a57ead';
export const MINI_SESSION_TEMPLATE_ID = '64cf8bb56ffa1d002b4e30a3';
export const INTRODUCTORY_CALL_TEMPLATE_ID = '647616a4ec1013002d0e571e';
export const INQUIRY_FORM_TEMPLATE_ID = '647616c144754202db991421';
export const INSTANT_BOOKING_TEMPLATE_ID = '647616d394b227051551bad8';

export const LEAD_FORM_WIZARD_TEMPLATE_IDS = [
    '64761681acda830335a42eca',
    '647616a4ec1013002d0e571e',
    '647616c144754202db991421',
    '647616d394b227051551bad8',
    '647616e627a61b056d827228',
    '64761706fb14d1002a1af1bf',
    '64cf8bb56ffa1d002b4e30a3',
    '64cf8c54b11218002db24e77',
    '654a32f60a0cca0027a57ead'
];

export enum ThankYouPagePreviews {
    SCHEDULE_PAY = 'https://public-content.honeybook.com/sys/svg/thank_you_schedule_pay.svg',
    SCHEDULE_ONLY = 'https://public-content.honeybook.com/sys/svg/thank_you_schedule.svg',
    PAY_ONLY = 'https://public-content.honeybook.com/sys/svg/thank_you_pay.svg',
    INQUIRY = 'https://public-content.honeybook.com/sys/svg/thank_you_inquiry.svg'
}
